import { render, staticRenderFns } from "./OperaGoodsShopWindow.vue?vue&type=template&id=008a6cc8&scoped=true&"
import script from "./OperaGoodsShopWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsShopWindow.vue?vue&type=style&index=0&id=008a6cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a6cc8",
  null
  
)

export default component.exports